<form
  [formGroup]="form"
  [patchForm]="courseFormValue"
  (ngSubmit)="onFormSubmit()"
  [canEditForm]="form"
  [canEdit]="[accessRights.Course_write]"
  #formRef="ngForm"
>
  <!-- Card -->
  <section class="card mb-3">
    <!-- Header -->
    <div class="card-header">
      <h3 class="card-title">
        {{ 'general.general' | translate }}
      </h3>
    </div>

    <!-- End Header -->

    <!-- Body -->
    <div class="card-body">
      <div class="row">
        <div class="col-lg-8">
          <div class="mb-4">
            <label class="form-label">
              <span class="text-danger" attr.aria-label="{{ '' | translate }}"
                >*</span
              >
              {{ 'courseModule.mainCourseProduct' | translate }}
              <small>({{ 'general.isRequired' | translate }})</small>
              <i
                class="ms-2 fa fa-question-circle"
                role="button"
                tabindex="0"
                [tooltip]="'courseModule.mainCourseProductTooltip' | translate"
              ></i>
            </label>

            <ng-select
              data-test-id="select-main-course-product-create-course"
              class="w-100"
              [loading]="isLoadingProduct$ | async"
              [items]="selectableProducts$ | async"
              [multiple]="false"
              bindLabel="description"
              formControlName="productId"
              [clearable]="false"
              bindValue="id"
              placeholder="{{ 'general.select' | translate }}"
              (search)="onSearchProduct($event)"
              required
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                <span data-test-id="customer-select-label">
                  {{ item.description }}
                </span>
              </ng-template>
            </ng-select>
            <p
              class="invalid-feedback"
              role="alert"
              aria-atomic="true"
              *ngIf="
                form.controls.productId.dirty && form.controls.productId.invalid
              "
            >
              <i
                role="img"
                class="fas fa-exclamation-circle"
                aria-hidden="true"
              ></i>
              {{ 'courseModule.mainCourseProduct' | translate }}
              {{ 'general.isInvalid' | translate }}
            </p>
          </div>

          <div *ngIf="course?.id">
            <div class="row">
              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'courseModule.courseStartDate' | translate }}
                </legend>

                <datetime-input
                  data-test-id="datetime-input-available-from-date"
                  style="overflow: hidden"
                  formControlName="startDate"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.startDate.dirty &&
                    form.controls.startDate.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.startDate.dirty &&
                    form.controls.startDate.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'courseModule.courseStartDate' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </fieldset>

              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'courseModule.courseEndDate' | translate }}
                </legend>

                <datetime-input
                  data-test-id="datetime-input-available-from-date"
                  style="overflow: hidden"
                  formControlName="endDate"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.endDate.dirty && form.controls.endDate.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.endDate.dirty && form.controls.endDate.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'courseModule.courseEndDate' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </fieldset>
            </div>
          </div>

          <div [hidden]="!(selectedProduct$ | async)">
            <div class="row">
              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'productModule.availableFromDate' | translate }}
                </legend>

                <datetime-input
                  data-test-id="datetime-input-available-from-date"
                  style="overflow: hidden"
                  formControlName="availableFromDate"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.availableFromDate.dirty &&
                    form.controls.availableFromDate.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.availableFromDate.dirty &&
                    form.controls.availableFromDate.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'productModule.availableFromDate' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </fieldset>

              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'productModule.availableTillDate' | translate }}
                </legend>

                <datetime-input
                  data-test-id="datetime-input-available-from-date"
                  style="overflow: hidden"
                  formControlName="availableTillDate"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.availableTillDate.dirty &&
                    form.controls.availableTillDate.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.availableTillDate.dirty &&
                    form.controls.availableTillDate.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'productModule.startDateEnrollment' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'courseModule.enrollmentStartDate' | translate }}
                </legend>

                <datetime-input
                  data-test-id="datetime-input-available-from-date"
                  style="overflow: hidden"
                  formControlName="startDateEnrollment"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.startDateEnrollment.dirty &&
                    form.controls.startDateEnrollment.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.startDateEnrollment.dirty &&
                    form.controls.startDateEnrollment.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'courseModule.enrollmentStartDate' | translate }}

                  {{ 'general.isInvalid' | translate | lowercase }}
                </p>
              </fieldset>

              <fieldset class="mb-4 col-lg-auto">
                <legend class="form-label">
                  {{ 'courseModule.enrollmentEndDate' | translate }}
                </legend>

                <datetime-input
                  style="overflow: hidden"
                  formControlName="endDateEnrollment"
                  defaultTimeValue="12:00"
                  [seDefaultTimeValue]="true"
                  class="flex-nowrap"
                  [attr.aria-invalid]="
                    form.controls.endDateEnrollment.dirty &&
                    form.controls.endDateEnrollment.invalid
                      ? 'true'
                      : null
                  "
                ></datetime-input>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.endDateEnrollment.dirty &&
                    form.controls.endDateEnrollment.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.enrollmentEndDate' | translate }}
                  {{ 'general.isInvalid' | translate | lowercase }}
                </p>
              </fieldset>
            </div>

            <label class="form-label">
              <span
                class="text-danger"
                attr.aria-label="{{ 'general.required' | translate }}"
                >*</span
              >
              {{ 'productModule.descriptionTooltip' | translate }}
              <small>({{ 'general.isRequired' | translate }})</small>
              <i
                class="ms-2 fa fa-question-circle"
                role="button"
                tabindex="0"
                [tooltip]="
                  'courseModule.internalDescriptionTooltip' | translate
                "
              ></i>
            </label>

            <input
              data-test-id="create-course-details-description"
              class="form-control"
              type="text"
              maxlength="255"
              formControlName="description"
              [attr.aria-invalid]="
                form.controls.description.dirty &&
                form.controls.description.invalid
                  ? 'true'
                  : null
              "
              required
            />

            <div class="row">
              <div class="col">
                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.description.dirty &&
                    form.controls.description.invalid &&
                    form.controls.description.errors &&
                    !form.controls.description.errors.maxlength
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.description' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    form.controls.description.dirty &&
                    form.controls.description.errors &&
                    form.controls.description.errors.maxlength
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.description' | translate }}
                  {{ 'general.isTooLong' | translate }}
                </p>
              </div>
              <div class="col">
                <character-counter
                  [currentText]="form.controls.description.value"
                  [maxCharacters]="descriptionMaxLength"
                ></character-counter>
              </div>
            </div>
            <label class="form-label" id="passwordLabel">
              {{ 'general.password' | translate }}

              <i
                class="ms-2 fa fa-question-circle"
                role="button"
                tabindex="0"
                [tooltip]="'courseModule.coursePassword' | translate"
              ></i>
            </label>

            <input
              aria-labelledby="passwordLabel"
              data-test-id="create-course-password"
              class="form-control"
              type="text"
              maxlength="255"
              formControlName="password"
              [attr.aria-invalid]="
                form.controls.password.dirty && form.controls.password.invalid
                  ? 'true'
                  : null
              "
            />
          </div>
        </div>
        <div class="col-lg-4">
          <h4
            >{{ 'courseModule.mainCourseProduct' | translate }}
            <i
              class="fa fa-question-circle ms-2 fs-5 text-body"
              role="button"
              tabindex="0"
              [tooltip]="'courseModule.mainCourseProductTooltip' | translate"
            ></i>
            <a
              class="ms-2 btn-link"
              routerLink="/products/{{ (selectedProduct$ | async)?.id }}"
              data-test-id="button-external-link"
            >
              <i
                role="img"
                class="fa fa-external-link-alt"
                attr.aria-label="{{ 'wcag.openInNewWindow' | translate }}"
              ></i>
            </a>
          </h4>

          <h5>{{ 'translationModule.productTranslations' | translate }}</h5>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let translation of selectedProductTranslations$ | async"
              >{{ translation.description }}</li
            >
          </ul>

          <h5 class="mt-3">{{ 'translationModule.tagsTranslations' }}</h5>
          <table class="table table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">En</th>
                <th scope="col">Nl</th>
                <th scope="col">De</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tag of selectedProductTags$ | async">
                <td
                  ><a routerLink="/tags/{{ tag.id }}">{{ tag.id }}</a></td
                >
                <td>{{ tag.description_en }}</td>
                <td>{{ tag.description_nl }}</td>
                <td>{{ tag.description_de }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Form Group -->
    </div>
    <!-- Body -->
  </section>
  <!-- End Card -->

  <!-- Pricing card -->
  <section class="card mb-3" [hidden]="!(selectedProduct$ | async)">
    <!-- Header -->
    <div class="card-header">
      <h3 class="card-title">{{ 'general.pricing' | translate }}</h3>
    </div>
    <!-- End Header -->

    <!-- Body -->
    <div class="card-body">
      <!-- Form Group -->
      <div class="row align-items-end">
        <!-- Precio general -->
        <div class="col-md-3 col-xl-2 mb-4">
          <label class="form-label d-block">
            {{ 'productModule.price' | translate }}
          </label>
          <div class="input-group">
            <div class="input-group-text">{{ countryCurrency }}</div>
            <input
              data-test-id="price-course-general"
              class="form-control"
              type="number"
              formControlName="price"
              min="0"
              pattern="^[0-9]+(\.[0-9]+)?$"
            />
          </div>
        </div>

        <div class="col-md-3 col-xl-2 mb-4">
          <label class="form-label d-block">
            {{ 'subscriptionModule.subscription' | translate }}
          </label>
          <div class="input-group">
            <div class="input-group-text">{{ countryCurrency }}</div>
            <input
              class="form-control"
              type="number"
              formControlName="linkedSubsPrice"
            />
          </div>
        </div>

        <ng-container *ngIf="hasExtendedCategories">
          <ng-container *ngFor="let i of showedCategories">
            <div class="col-md-3 col-xl-2 mb-4">
              <label class="form-label d-block">
                <ng-container
                  *ngIf="
                    'category' + i + 'desc'
                      | getCategoryDescription
                      | async as desc
                  "
                >
                  {{
                    desc &&
                    desc !== i.toString() &&
                    desc !== ('category0desc' | getCategoryDescription | async)
                      ? desc
                      : ('productModule.category' + i + 'Price' | translate)
                  }}
                </ng-container>
              </label>
              <div class="input-group">
                <div class="input-group-text">{{ countryCurrency }}</div>
                <input
                  class="form-control"
                  type="number"
                  [formControlName]="'category' + i + 'Price'"
                />
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!--Button show more or less -->
        <div class="col-md-auto col-xl-2 mb-4">
          <button
            type="button"
            class="btn btn-ghost-primary btn-sm mt-4"
            aria-controls="showPrice"
            (click)="$event.preventDefault(); showPrice = !showPrice"
          >
            {{
              showPrice
                ? ('productModule.removeMore' | translate)
                : ('productModule.showMore' | translate)
            }}
          </button>
        </div>
      </div>
      <!-- subform prices-->
      <section class="card mb-3" *ngIf="showPrice" id="showPrice">
        <div class="card-body">
          <div class="row">
            <ng-container *ngIf="hasExtendedCategories">
              <ng-container *ngFor="let i of hiddenCategories">
                <div class="col-md-3 col-xxl-2 mb-3">
                  <label class="form-label">
                    <ng-container
                      *ngIf="
                        'category' + i + 'desc'
                          | getCategoryDescription
                          | async as desc
                      "
                    >
                      {{
                        desc &&
                        desc !== i.toString() &&
                        desc !==
                          ('category0desc' | getCategoryDescription | async)
                          ? desc
                          : ('productModule.category' + i + 'Price' | translate)
                      }}
                    </ng-container>
                  </label>
                  <div class="input-group">
                    <div class="input-group-text">{{ countryCurrency }}</div>
                    <input
                      class="form-control"
                      type="number"
                      [formControlName]="'category' + i + 'Price'"
                    />
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </section>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.vat' | translate }}
        </label>
        <div class="row">
          <div class="col-md-6 col-xxl-4">
            <div class="input-group">
              <div class="input-group-text">%</div>
              <input class="form-control" type="number" formControlName="vat" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Body -->
  </section>
  <!-- End Card -->

  <div *ngIf="showSubmitButton" class="form-footer">
    <button
      data-test-id="button-save-general-course"
      class="btn btn-primary"
      type="submit"
      [disabled]="!form.dirty"
      [canSee]="[accessRights.Course_write]"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
